// extracted by mini-css-extract-plugin
export default {"container":"Z0b4KycMUtNSiciIGfQr","details":"y3EV623_7F_7t18VL_8w"};